import { reduxKey } from './constants';
import { isFlagEnabled } from '@wix/da-react-context/pkg/flags/helpers';
/**
 * Get all flags
 */ export const getFlags = (state)=>{
    return state[reduxKey] || {};
};
/**
 * Check if flag is enabled
 */ export const flagEnabled = (state, flag)=>{
    return isFlagEnabled(getFlags(state), flag);
};
/**
 * Get all flags
 */ export const getEnabledFlagsList = (state)=>{
    const flags = getFlags(state);
    return Object.keys(flags).filter((flag)=>!!flags[flag]);
};
